import { render, staticRenderFns } from "./course-item.vue?vue&type=template&id=4ac6cf07&scoped=true"
import script from "./course-item.vue?vue&type=script&lang=js"
export * from "./course-item.vue?vue&type=script&lang=js"
import style0 from "./course-item.vue?vue&type=style&index=0&id=4ac6cf07&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac6cf07",
  null
  
)

export default component.exports